import React from "react";
import { I18n } from "react-redux-i18n";
import { NewTable } from "@common/components/new-table";
import { MODULE_NAME } from "@modules/invite-status/constants/shared";
import { Flex } from "@common/components/Flex";
import { RelativeChooserProps, useRelativeChooserController } from "./fhq-invite-relative-chooser.controller";

import "./fhq-invite-relative-chooser.styles.scss";

export const RelativeChooser: React.FC<RelativeChooserProps> = (props) => {
  const { selectedIndividuals } = props;
  const {
    loadingIndividuals,
    individuals,
    handleSelectedItemsChange,
    getId,
    itemUniqProperty,
    handleLoadData,
    individualsTotalCount,
    individualsLoadMetadata,
    processedColumns,
  } = useRelativeChooserController(props);

  return (
    <div className="InviteStatusRelativeChooser">
      <h6 className="InviteStatusRelativeChooser__title">{I18n.t("Select Individuals To Invite")}</h6>
      <Flex className="InviteStatusRelativeChooser__content-wrapper">
        <NewTable
          disableAutoInit
          classes={{
            root: "InviteStatusRelativeChooser__table",
          }}
          data={individuals}
          getId={getId}
          itemUniqProperty={itemUniqProperty}
          moduleName={`${MODULE_NAME}_patient_invite_individuals_chooser`}
          columns={processedColumns}
          loading={{
            list: loadingIndividuals,
          }}
          noDataMessage={I18n.t("There no individuals to display")}
          errorMessage={{ list: I18n.t("Failed to load individuals history") }}
          infiniteScroll
          selection={{
            type: "multiple",
            items: selectedIndividuals,
            onChange: handleSelectedItemsChange,
          }}
          totalItemsCount={individualsTotalCount}
          loadMetadata={individualsLoadMetadata}
          onLoadData={(loadMetadata) => {
            return handleLoadData({
              loadedIndividuals: individuals,
              ...loadMetadata,
            });
          }}
        />
      </Flex>
    </div>
  );
};
